var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "forgotPasswordForm",
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _vm.currentAward
        ? _c("p", { staticClass: "orangetext" }, [
            _vm._v(
              "\n        Fill in the e-mail linked with your account below to start the password restoration process.\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "form-group",
          attrs: { prop: "email", error: _vm.$t(_vm.formErrors.get("email")) },
        },
        [
          _c("el-input", {
            attrs: {
              name: "email",
              placeholder: _vm.$t("auth.login.email_label") + " *",
              type: "text",
            },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { xs: 24 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "loginButton",
                  attrs: { loading: _vm.loading },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n                Submit\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }